import { v4 as uuid } from 'uuid'
import React, { Component } from 'react'
import { Select } from 'components/forms/components'

const options = [
    {value: 1,  label: "OCT - DIC"},
    {value: 2,  label: "ENE - MAR"},
    {value: 3,  label: "ABR - JUN"},
    {value: 4,  label: "JUL - SEP"},
]

export default class TrimestreSelect extends Component {

    /**
     * Constructor
     * 
     * @param {Object} props 
     */
    constructor(props) {
        super(props)
    }

    /**
     * Render
     * 
     * @returns {Component}
     */
    render() {
        const labelId = "trimestre_select-id-" + uuid()
        return (
            <Select 
                ref          = {(ref) => this.select = ref}
                width        = {this.props.width ?? "100%"}
                minWidth     = {this.props.minWidth}
                items        = {options}
                register     = {this.props.register}
                defaultValue = {this.props.defaultValue}
                onChange     = {this.props.onChange}
                className    = {this.props.className}
                name         = {this.props.name ?? "trimestre"}
                errors       = {this.props.errors}
                wantToReset  = {this.props.wantToReset}
                labelId      = {labelId} 
                label        = {this.props.label ?? "Trimestre"}/>
        )
    }
}
